import { Component ,Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-view-unavailability',
  templateUrl: './view-unavailability.component.html',
  styleUrls: ['./view-unavailability.component.scss']
})
export class ViewUnavailabilityComponent {
  public employeeArr:any[]=[]
  public date:any = ""

  constructor( @Inject(MAT_DIALOG_DATA) public dialogData: any){}

  ngOnInit(): void {
    if(this.dialogData){
      this.date = this.dialogData.fDate
      this.employeeArr = this.dialogData.unav;
    }
  }
}
